module.exports = __webpack_public_path__ + "a4e0d32f8d8cb67da4af27c3f948600d.ttf";